import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
import { DEAL_TYPES } from 'site-modules/shared/components/deal/deal-constants';

/**
 * Checks if rating graph promo can be shown for a used vehicle.
 * @param {object} vinData
 * @return {boolean}
 */
export const getPriceCheckerPromoAvailability = vinData => {
  const { maxGreatPrice, maxGoodPrice, maxFairPrice } = vinData?.computedDisplayInfo?.priceValidation ?? {};
  const displayPrice = vinData?.prices?.advertisedPrice ?? 0;
  const dealType = vinData?.computedDisplayInfo?.priceValidation?.dealType ?? '';
  const listPriceEstimate = vinData?.computedDisplayInfo?.priceValidation?.listPriceEstimate ?? 0;
  const type = vinData?.type;

  return (
    isUsed(type) &&
    !!displayPrice &&
    !!maxGreatPrice &&
    !!maxGoodPrice &&
    !!maxFairPrice &&
    DEAL_TYPES.includes(dealType) &&
    !!listPriceEstimate
  );
};
